import AffinityCategoriesTable from './AffinityCategoriesTable';
import { SoftButton } from '../Button';
import Stack from '../Stack';
import { useFlagActions } from 'utils/hooks/flags';
import { DATA_SOURCES } from '@/config/constants';
import { useAffinityCategoryLinks, useEntity } from 'utils/hooks/api';
import { useMutation } from 'react-query';
import { withMixpanelClick } from 'utils/app';

const RequestAnalysisButton = withMixpanelClick(SoftButton, 'request_analysis');

function CatFiveAffinityCategoriesTable({
    categoryId,
    countryId,
    categoryName,
}) {
    const { requestAnalysis } = useFlagActions();
    const { mutateAsync: submitRequest, status } = useMutation(
        ({ suggestion, comment }) => requestAnalysis(suggestion, comment),
    );
    const linkedAffinitiesQuery = useAffinityCategoryLinks({
        categories: categoryId ? [categoryId] : null,
        countries: countryId ? [countryId] : null,
        enabled: !!(countryId && categoryId),
    });

    const linkedAffinityId = linkedAffinitiesQuery.data?.[0]?.affinity_id;

    const affinityQuery = useEntity({
        id: linkedAffinityId,
        entityType: 'affinities',
        dataSource: DATA_SOURCES.GOOGLE,
        minimal: false,
        enabled: !!linkedAffinityId,
    });

    const { groups } = affinityQuery.data || {};

    if (!linkedAffinitiesQuery.isLoading && !linkedAffinityId) {
        return (
            <Stack
                $space="1rem"
                $direction="column"
                css="padding: 3rem; display: flex; flex-direction: column; align-items: center;"
            >
                <span>Industries data is not available for this category.</span>
                <RequestAnalysisButton
                    disabled={status === 'loading'}
                    fetching={status === 'loading'}
                    onClick={() =>
                        submitRequest({
                            suggestion: 'related category',
                            comment: `Add "${categoryName}" to industries analysis`,
                        })
                    }
                    mixpanelMeta={{ categoryName, analysisType: 'industries' }}
                >
                    Request Analysis
                </RequestAnalysisButton>
            </Stack>
        );
    }

    return (
        <AffinityCategoriesTable
            icon="category"
            title="Industries"
            subtitle="How is this category performing across industries?"
            tooltipKey="industriesHelp"
            tooltipExample={null}
            countryId={countryId || null}
            categoryIds={groups || null}
            affinityId={linkedAffinityId || null}
        />
    );
}

export default CatFiveAffinityCategoriesTable;
